import React from 'react';

const PendingStatusIcon = () => (
  <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7.51367" cy="9.74365" r="6" stroke="white" strokeWidth="3" />
    <rect x="5.49805" y="0.338135" width="4.03279" height="6.32682" fill="#27282D" />
  </svg>
);

export default PendingStatusIcon;
